<template>

  <div class="row">
	 
    <div class="col-md-12">
      <h4 class="title">People</h4>
      <p class="category">
      Database of people you have added.
      </p>
    </div>
    <div class="col-md-12 card">
      <div class="card-header">
        <div class="category">Extended</div>
      </div>
      <div class="card-body row">
        <div class="col-sm-6">
          <el-select style="display:none;"
            class="select-default"
            v-model="pagination.perPage"
            placeholder="Per page">
            <el-option
              class="select-default"
              v-for="item in pagination.perPageOptions"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </div>
        <div class="col-sm-6">
          <div class="pull-right">
            <fg-input class="input-sm"
                      placeholder="Search By Name or Gov ID"
                      v-model="searchQuery"
                      v-on:change="searchingPeople"
                      addon-right-icon="nc-icon nc-zoom-split">
            </fg-input>
          </div>
        </div>
        
        
            <div style="">
		  <fg-input >
                  <el-select class="select-primary"
                             size="large"
                             @change="onSortTypeChange($event)"
                             placeholder="Sort By"
                             v-model="sortType"

                             >
                    <el-option v-for="option in selects.sortType"
                               class="select-danger"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
                </fg-input>

    </div>
        
        
        
        <div id="cs_companies_pg" class="col-sm-12 mt-2">
          <el-table class="table-striped"
                    :data="tableData"
                    border
                    style="width: 100%" @row-click="viewPerson">
            <el-table-column v-for="column in tableColumns"
                             :key="column.label"
                             :min-width="column.minWidth"
                             :prop="column.prop"
                             :label="column.label"
                             style="font-size:13px;!important"
                             >
            </el-table-column>
              <el-table-column label="Citizenship" width="120">
            		<template slot-scope="scope">
						{{getCitizenship(scope.row.citizenship)}}
					</template>
            
            </el-table-column>
            	
						
             <el-table-column label="Notes" width="200">
            		<template slot-scope="scope">
						{{scope.row.notes}}
						
						<div v-if="scope.row.shareholder_companies">
    				   
    					 <span v-for="coy in scope.row.shareholder_companies"> 
    					  Representative of 
    					 <span style="font-weight:bold;">	{{coy.company_name}} ({{coy.company_reg_num}})</span>
    					 </span>
    					 </div> 
    					 <div v-else>N.A.</div>
          			</template>
            
            </el-table-column>
            
               <el-table-column label="" width="90">
            		<template slot-scope="scope">
            			 <p-button type="success" size="sm" icon @click="goToEditPerson(scope.row)">
                 			 <i class="fa fa-edit"></i>
                		</p-button>
					</template>
               </el-table-column>
               
               
            <!--<el-table-column
              :min-width="50"
              fixed="right"
              class-name="td-actions"
              label="" >
              <template slot-scope="props">
                <p-button type="warning" size="sm" icon @click="handleTask(props.$index, props.row)">
                  <i class="fa fa-briefcase"></i>
                </p-button>

              </template>
            </el-table-column>-->
          </el-table>
        </div>
        <div class="col-sm-6 pagination-info">
          <p class="category">Showing {{from + 1}} to {{to}} of {{pagination.total}} entries</p>
        </div>
        <div class="col-sm-6">
          <p-pagination class="pull-right"
                        v-model="pagination.currentPage"
                        :per-page="pagination.perPage"
                        :total="pagination.total">
          </p-pagination>
        </div>
      </div>
    </div>

    
     <div style="text-align:right;width:100%">
 	 <p-button type="info" @click="goToCreatePerson()">
             <i slot="label" class="nc-icon nc-settings-gear-65"></i>
                Add New Person
      </p-button>
  </div>
  
  <div style="width:100%">
   <h4>
  	Shareholder/Member Companies
   </h4>
    <p class="category">
     Companies that are shareholders/members of entities under your charge.
      </p>
  </div>
  <card>
		<el-table :data="shc" >
					<el-table-column label="Company Name" property="company_name" width="250"></el-table-column>
					<el-table-column label="Company Registration Number" property="company_reg_num" width="150"></el-table-column>
					<el-table-column label="Country" property="country" width="150"></el-table-column>
					<el-table-column label="Address" property="address" width="350"></el-table-column>
					 <el-table-column label="Representative"  width="310">
            		<template slot-scope="scope">
						<span v-if="scope.row.person">{{scope.row.person.first_name}} {{scope.row.person.last_name}} ({{scope.row.person.gov_id}}) </span>
          			</template>
            
            </el-table-column>
              <el-table-column label="" width="90">
            		<template slot-scope="scope">
            			 <p-button type="success" size="sm" icon @click="goToEditShareholderCompany(scope.row)">
                 			 <i class="fa fa-edit"></i>
                		</p-button>
					</template>
               </el-table-column>
		</el-table>
   <p-button type="info" @click="goToCreateShareholderCompany()">
             <i slot="label" class="nc-icon nc-settings-gear-65"></i>
                Add New Shareholder Company
      </p-button>
  </card>
  
  
  </div>
</template>
<script>
  import Vue from 'vue'
  
  import ApiService from 'src/services/api.service'
  import swal from 'sweetalert2'
  import {Table, TableColumn, Select, Option} from 'element-ui'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  import users from './users'
  import {CommonService} from 'src/services/common.service'
  
  
  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Select)
  Vue.use(Option)
  export default{
    components: {
      PPagination
    },
     
    computed: {
      pagedData () {
        //return this.tableData.slice(this.from, this.to)
      },
      /***
       * Searches through table data and returns a paginated array.
       * Note that this should not be used for table with a lot of data as it might be slow!
       * Do the search and the pagination on the server and display the data retrieved from server instead.
       * @returns {computed.pagedData}
       */
     /* queriedData () {
        if (!this.searchQuery) {
          this.pagination.total = this.tableData.length
          return this.pagedData
        }
        let result = this.tableData
          .filter((row) => {
            let isIncluded = false
            for (let key of this.propsToSearch) {
              let rowValue = row[key].toString().toLowerCase()
              if (rowValue.includes && rowValue.includes(this.searchQuery.toLowerCase())) {
                isIncluded = true
              }
            }
            return isIncluded
          })
        this.pagination.total = result.length
        return result.slice(this.from, this.to)
      },*/
      to () {
        let highBound = this.from + this.pagination.perPage
        if (this.total < highBound) {
          highBound = this.total
        }
        return highBound
      },
      from () {
        return this.pagination.perPage * (this.pagination.currentPage - 1)
      },
      total () {
      //  this.pagination.total = this.tableData.length
        return this.pagination.total
      }
    },
    data () {
      return {
      	shc:[],
      	sortType:1, 
      	selects: {
		   sortType:[
            {value: 1, label: 'Sort: Date Added'},
            {value: 2, label: 'Sort: First Name'},

		   ],
		},
        pagination: {
          perPage: 20,
          currentPage: 1,
          perPageOptions: [5, 10, 25, 50],
          total: 0
        },
        searchQuery: '',
        loadedPage : 0,
        propsToSearch: ['gov_id', 'first_name'],
        tableColumns: [
          {
            prop: 'first_name',
            label: 'First Name',
            minWidth: 120
          },
          {
            prop: 'last_name',
            label: 'Last Name',
            minWidth: 100
          },
          {
            prop: 'gov_id',
            label: 'ID Number',
            minWidth: 90
          },
           {
            prop: 'email',
            label: 'Email',
            minWidth: 100
          },
          {
            prop: 'address_1',
            label: 'Address',
            minWidth: 250
          },
          {
            prop: 'contact_num',
            label: 'Contact Number',
            minWidth: 90
          },

          
 


        ],
        tableData: []
      }
    },
	
    mounted() {
      swal.showLoading();
      let uri = this.$base_url+'/api/v1/entities/get/people?';
      ApiService.get(uri).then(response => {
      	
      	 let people = response.data.people.data;
      	 this.pagination.total = response.data.people.total;
      	 this.pagination.currentPage = response.data.people.current_page;
      	 this.loadedPage = response.data.people.current_page;
      	 
      	 
      	this.shc = response.data.shc
      	
         this.tableData = people;
         swal.close();
        
      })
    },
    watch: {
     'pagination.currentPage': function ()  {
 
     		if(this.pagination.currentPage && this.loadedPage!=this.pagination.currentPage && this.loadedPage){
    			this.loadPage();
    		}
    	}
	},
    methods: {
      searchingPeople(){
          this.loadPage();
      },
             onSortTypeChange(){
       		this.loadPage();
       },
      loadPage(){
      	swal.showLoading();
    
      	
        let uri = this.$base_url+'/api/v1/entities/get/people?page='+this.pagination.currentPage+"&qq="+this.searchQuery+"&sort="+this.sortType;
		  ApiService.get(uri).then(response => {

			 
			 let people = response.data.people.data;
			 this.pagination.total = response.data.people.total;
			 this.pagination.currentPage = response.data.people.current_page;
			 this.pagination.perPage = response.data.people.per_page;
			 this.loadedPage = response.data.people.current_page;
	 	
			 this.tableData = people;
			 swal.close();
	
		  })
      
      },

      getCitizenship(code){		
      		return CommonService.getCitizen(code);
      },
      getCountry(code){	
      		return CommonService.getCountry(code);
      },
      goToEditPerson(row){
      	 this.$router.push( '/create-person/'+row.id)
      },
      goToCreatePerson(){
      	 this.$router.push( '/create-person/0')
      },
      goToCreateShareholderCompany(){
      	this.$router.push( '/edit-shareholder-company/0')
      },
      goToEditShareholderCompany(row){
      		this.$router.push( '/edit-shareholder-company/'+row.id)
      },
      handleTask (index, row) {
        let entity_id = this.tableData[index].id;
        
        this.$router.push( '/create-task/'+entity_id)
      },
      viewPerson(row) {

      },
      handleEdit (index, row) {
      
        alert(`Your want to edit ${row.name}`)
      },
      handleDelete (index, row) {
        let indexToDelete = this.tableData.findIndex((tableRow) => tableRow.id === row.id)
        if (indexToDelete >= 0) {
          this.tableData.splice(indexToDelete, 1)
        }
      }
    }
  }
</script>
<style lang="scss">

  
</style>
